var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickSightUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "700.000000pt",
    height: "500.000000pt",
    viewBox: "150 400 950.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1080.000000) scale(0.100000,-0.100000)",
    fill: "#2514BE",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7880 8500 c-80 -28 -302 -105 -495 -172 -192 -66 -363 -130 -379 -141 -57 -40 -74 -138 -33 -197 30 -46 80 -73 131 -72 24 0 146 37 300 92 143 50 263 89 268 88 9 -3 -1169 -1648 -1180 -1648 -7 0 -449 428 -1246 1204 -164 160 -302 292 -306 294 -7 2 -1496 -1850 -1528 -1902 -12 -19 -9 -29 37 -97 27 -42 64 -104 81 -138 17 -33 33 -61 36 -61 2 0 317 392 700 871 383 478 699 869 703 867 5 -2 327 -313 717 -693 390 -379 741 -720 780 -757 l70 -67 389 542 c215 298 531 738 703 977 171 239 317 437 322 438 6 2 10 -20 10 -54 0 -31 5 -168 11 -303 10 -221 13 -250 32 -285 57 -102 214 -99 268 6 l21 41 -21 501 c-12 276 -24 520 -26 542 -12 87 -86 158 -176 169 -36 5 -71 -4 -189 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7610 4815 l0 -1885 465 0 465 0 0 1885 0 1885 -465 0 -465 0 0 -1885z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4490 4505 l0 -1575 463 2 462 3 0 1570 0 1570 -462 3 -463 2 0 -1575z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6050 3770 l0 -840 465 0 465 0 0 840 0 840 -465 0 -465 0 0 -840z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3895 2601 c13 -38 31 -105 40 -150 l18 -81 421 -2 421 -3 3 -163 2 -163 153 3 152 3 3 163 2 162 625 0 625 0 0 -165 0 -165 155 0 155 0 0 165 0 165 625 0 625 0 0 -165 0 -165 155 0 155 0 0 165 0 165 570 0 570 0 0 150 0 150 -2749 0 -2748 0 22 -69z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickSightUser);
export default __webpack_public_path__ + "static/media/quickSightUser.062dfabc574fa9f4c311e65fd4a7c1d5.svg";
export { ForwardRef as ReactComponent };